import React from 'react';
import ReactTooltip from 'react-tooltip';
import './TooltipDefinition.css';

export default class TooltipDefinition extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tooltipOpen: false
        };
    }

    toggle = () => {
        this.setState({
            tooltipOpen: true || !this.state.tooltipOpen
        });
    }

    render() {
        let {target, name, definition, type, place, delayShow} = this.props;
        return (
            <div>
            <span data-tip data-for={target} data-delay-show={delayShow} className="d-flex align-items-center">
                <div className="w-100 kpi-option" >{name}</div>
            </span>
            <ReactTooltip id={target} type={type} className='extraClass' place={place} effect='solid' offset={{left: 10}}>
            <span>{definition}</span>
           </ReactTooltip>
           </div>
        );
    }
}